import { api } from '@/lib/api-manager'
import type { RequestFilter } from '@/types/requests/request-filter'

export async function getRequests(filter?: Partial<RequestFilter>) {
  const response = await api.get('v1/requests', { params: filter })
  return response.data
}
